import { useEffect } from "react";

export const DisableScreenshot = () => {
  useEffect(() => {
    const handleKeyUpScreen = (e: KeyboardEvent) => {
      if (e.key === "PrintScreen") {
        document.body.style.overflowY = "hidden";
        document.body.style.display = "none";
      }
    };

    const handleVisibilityChange = () => {
      if (document.visibilityState === "hidden") {
        document.body.style.background = "#000";
        document.body.style.overflowY = "hidden";
      }
    };

    document.addEventListener("keyup", handleVisibilityChange);
    document.addEventListener("keydown", handleKeyUpScreen);
    document.addEventListener("keyup", handleKeyUpScreen);

    return () => {
      document.removeEventListener("keyup", handleVisibilityChange);
      document.removeEventListener("keyup", handleKeyUpScreen);
      document.removeEventListener("keydown", handleKeyUpScreen);
    };
  }, []);

  return null; // ← important
};
